import { extends as _extends, objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useImageLoaded } from '@costar-ui/hooks';
import React__default, { forwardRef, useMemo } from 'react';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import ArtworkContactProfile from '../artwork/artwork-contact-profile.esm.js';
import Slot from '../layout/slot/slot.esm.js';
import Initials from '../initials/initials.esm.js';

var _excluded = ["src", "alt", "title", "initials", "imageRef", "placeholder", "size", "className", "testId", "suppressOnImageError"];
var PrivateAvatar = /*#__PURE__*/forwardRef(function Avatar(props, ref) {
  var theme = useComponentTheme('Avatar');
  var _props = _objectSpread2({}, props),
    src = _props.src,
    alt = _props.alt,
    title = _props.title,
    initials = _props.initials,
    imageRef = _props.imageRef,
    _props$placeholder = _props.placeholder,
    placeholder = _props$placeholder === void 0 ? false : _props$placeholder,
    _props$size = _props.size,
    size = _props$size === void 0 ? 'xs' : _props$size,
    className = _props.className,
    testId = _props.testId,
    suppressOnImageError = _props.suppressOnImageError,
    rest = _objectWithoutProperties(_props, _excluded);
  var wrapperClasses = useMemo(function () {
    return theme.base({
      className: className,
      size: size
    });
  }, [theme, size, className]);
  var imageMeta = useImageLoaded({
    src: src
  });
  if (suppressOnImageError && imageMeta.state === 'error') {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Slot, _extends({
    testId: testId,
    ref: ref,
    className: "csg-tw-avatar-image-wrapper relative overflow-hidden ".concat(imageMeta.state === 'loaded' && src ? 'border border-neutral' : 'border-transparent', " ").concat(wrapperClasses),
    justify: "center",
    alignItems: "center"
  }, rest), src ? /*#__PURE__*/React__default.createElement("img", {
    className: "csg-tw-avatar-image absolute left-0 top-0 z-[1] h-auto min-h-full w-full max-w-full object-cover",
    src: src,
    alt: alt,
    title: title,
    ref: imageRef
  }) : null, initials !== null && initials !== void 0 && initials.firstInitial || initials !== null && initials !== void 0 && initials.lastInitial ? /*#__PURE__*/React__default.createElement(Initials, {
    firstInitial: initials === null || initials === void 0 ? void 0 : initials.firstInitial,
    lastInitial: initials === null || initials === void 0 ? void 0 : initials.lastInitial
  }) : placeholder ? /*#__PURE__*/React__default.createElement(ArtworkContactProfile, {
    className: "h-auto min-h-full w-full max-w-full origin-bottom scale-[1.2] bg-neutral-subtlest"
  }) : null);
});
var Avatar = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(PrivateAvatar, _extends({
    ref: ref
  }, props));
});
Avatar.displayName = 'Avatar';
var Avatar$1 = Avatar;

export { PrivateAvatar, Avatar$1 as default };
//# sourceMappingURL=avatar.esm.js.map
